<div class="wrapper flex flex-col">
  <div class="heading text-type-2">Work condition</div>
  <div class="form-section">
    <mat-radio-group
      [formControl]="form.controls.dayType"
      class="radio-group"
      >
      <!-- Workday option -->
      @for (option of workdayOptions; track option) {
        <mat-radio-button
          [value]="option.value"
          class="radio-option"
          >
          {{ option.label }}
        </mat-radio-button>
      }

      <hr class="section-divider" />

      <!-- Non-workday group header -->
      <div class="group-header">NON-WORKDAY</div>

      <!-- Non-workday options -->
      @for (option of nonWorkdayOptions; track option) {
        <mat-radio-button
          [value]="option.value"
          class="radio-option"
          >
          {{ option.label }}
        </mat-radio-button>
      }
    </mat-radio-group>

    <!-- Comment field - only show for "Other" (code 1004) -->
    @if (form.controls.dayType.value === 1004) {
      <div class="comment-section">
        <label class="comment-label">COMMENT:</label>
        <textarea
          [formControl]="form.controls.note"
          class="comment-textarea"
          rows="4"
        ></textarea>
      </div>
    }
  </div>

  <app-actions-section
    [disableAddMenu]="true"
    [disableOptionMenu]="true"
    class="actions-section w-[455px]"
    />
</div>
